export type SocketEventHandler = ( payload: any ) => void;

export interface RealtimeSocket {
  disconnected: boolean;
  connected: boolean;
  on: ( event: string, handler: SocketEventHandler ) => RealtimeSocket;
  off: ( event: string, handler?: SocketEventHandler ) => RealtimeSocket;
  emit: ( event: string, payload?: any ) => RealtimeSocket;
  disconnect: () => void;
}

export const REALTIME_EVENTS = [
  "channel:qr",
  "channel:status",
  "channel:history-sync",
  "channel:new-message",
  "service:new",
  "service:att:start",
  "service:att:transfer",
  "service:att:abandon",
  "service:att:close",
  "notification:new",
  "message:att-status",
  "presence:snapshot",
  "presence:update",
] as const;
